import React, { useState, useEffect } from 'react';
import { Formik, Form, Field } from 'formik';
import { Button, Box, Checkbox, FormControlLabel } from '@mui/material';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { saveCustomerForCheckout } from '@/services/reservationService';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { setUserCardList } from '@/redux/actions/cardListActions';
import './PaymentDataView.scss';
import Label from '@/components/form/Label/Label';

const BackButton = props => {
  const { languageData, onBack } = props;
  return (
    <FlexContainer className={'BackButton align-items-end'}>
      <i className="fa fa-chevron-left" onClick={onBack}></i>
      <Label className={'fontWhite text-12 margl10'} onClick={onBack}>
        {languageData === 'EN' ? 'Back' : 'Volver'}
      </Label>
    </FlexContainer>
  );
};

const PaymentDataView = props => {
  const {
    initialValues,
    onSubmit,
    loading,
    onBack,
    languageData,
    validationSchema,
  } = props;

  const userCardList = useSelector(state => state.userCardList);
  const dispatch = useDispatch();
  const stripe = useStripe();
  const elements = useElements();

  const handleFormSubmit = async (values, { setSubmitting }) => {
    if (!stripe || !elements) {
      console.error('Stripe.js has not loaded yet.');
      return;
    }

    setSubmitting(true);

    const cardElement = elements.getElement(CardElement);

    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: 'card',
      card: cardElement,
      billing_details: {
        name: values.cardHolder,
        email: values.email,
      },
    });

    if (error) {
      console.error('[Stripe Error]', error);
      setSubmitting(false);
      return;
    }

    console.log('[PaymentMethod]', paymentMethod);

    let customerId = null;

    const customerResponse = await saveCustomerForCheckout({
      customerEmail: values.email,
      customerName: values.cardHolder,
      paymentMethodId: paymentMethod?.id,
    });

    if (!customerResponse) {
      throw new Error('Fallo desconocido al crear el Customer.');
    } else {
      console.log('Customer ID obtenido/creado:', customerResponse);
      customerId = customerResponse?.customerId;

      const currentDefaultAttr = values?.isDefault;
      const finalDefaultAttr =
        userCardList.length === 0 && !currentDefaultAttr
          ? true
          : currentDefaultAttr;

      const updatedUserCardList = values.isDefault
        ? userCardList.map(card => ({
            ...card,
            isDefault: false,
          }))
        : userCardList;

      const newCardList = [
        ...updatedUserCardList,
        {
          ...paymentMethod,
          customerId: customerId,
          isDefault: finalDefaultAttr,
        },
      ];

      dispatch(setUserCardList(newCardList));
    }

    console.log('sssss: ', values);

    const dataForHook = {
      token: paymentMethod.id,
      cardNumber: paymentMethod.card?.last4,
      customerId: customerId,
      email: values.email,
      isDefault: values.isDefault,
      cardHolder: values.cardHolder,
    };

    console.log('daf for h', dataForHook);

    await onSubmit(dataForHook);

    setSubmitting(false);
    onBack();
  };

  const cardElementOptions = {
    style: {
      base: {
        color: '#FFFFFF',
        fontFamily: 'Manrope, sans-serif',
        fontSize: '16px',
        '::placeholder': {
          color: 'rgba(255, 255, 255, 0.5)',
        },
      },
      invalid: {
        color: '#ff4d4d',
        iconColor: '#ff4d4d',
      },
    },
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);

    return () => clearTimeout(timer);
  }, []);

  return (
    <FlexContainer className="PaymentDataView flex-column padlr10 justify-start items-center bgGradientBlue fontWhite height-950px">
      <BackButton languageData={languageData} onBack={onBack} />

      <FlexContainer className={'flex-column padlr10 margb30'}>
        <Label className={'titlecenter text-34 margt30'}>
          {languageData === 'EN' ? 'Add a new ' : 'Agregar una nueva '}
        </Label>
        <Label className={'titlecenter text-36'}>
          {languageData === 'EN' ? 'Payment \ncard' : 'tarjeta de pago'}
        </Label>

        <Label
          className={
            'titlecenter text-14 margtb20 opacity-70 whitespace-preline'
          }
        >
          {languageData === 'EN'
            ? 'Enter your card details securely to\nadd a new payment method'
            : 'Ingresa los datos de tu tarjeta de forma segura para\nagregar un nuevo método de pago'}
        </Label>

        <FlexContainer className={'flex-column align-items-center margtb10'}>
          <Formik
            initialValues={initialValues}
            onSubmit={handleFormSubmit}
            validationSchema={validationSchema}
          >
            {({ isSubmitting, values, setFieldValue }) => (
              <Form className={'align-items-center format50 m-format100'}>
                <Box mb={2} position="relative">
                  <Field name="cardHolder">
                    {({ field, form }) => {
                      const hasError =
                        form.errors.cardHolder && form.touched.cardHolder;

                      return (
                        <Box className="pos-rel width100">
                          <input
                            {...field}
                            type="text"
                            maxLength={50}
                            placeholder="Juan Pablo Rodriguez"
                            onInput={e => {
                              field.onChange(e);
                              // Limpiar entrada
                              e.target.value = e.target.value.replace(
                                /[^A-Za-záéíóúñÁÉÍÓÚÑ\s\-\.]/g,
                                '',
                              );
                            }}
                            onKeyPress={e => {
                              if (!/[A-Za-záéíóúñÁÉÍÓÚÑ\s\-\.]/.test(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            onBlur={e => {
                              field.onBlur(e);
                              form.setFieldTouched('cardHolder', true);
                            }}
                            className="grayShadowBottom placeholder-custom width100 padt30 padr14 padb10 padl12 fontWhite text-16 boxSizing_borderBox outlineNone borderrad18"
                            style={{
                              backgroundColor: hasError
                                ? 'rgba(255, 87, 87, 0.1)'
                                : 'rgba(255,255,255,0)',
                              border: hasError
                                ? '2px solid rgba(255, 87, 87, 0.8)'
                                : '2px solid rgba(255,255,255,0.4)',
                              transition: 'all 0.2s ease',
                              paddingRight: hasError ? '40px' : '14px',
                            }}
                            onFocus={e => {
                              e.target.style.backgroundColor =
                                'rgba(255,255,255,0.12)';
                              e.target.style.borderColor =
                                'rgba(255,255,255,0.6)';
                            }}
                          />
                          <label
                            htmlFor="cardHolder"
                            className="pos-abs top8 left16 text-14 pointerEventsNone"
                            style={{
                              color: hasError
                                ? 'rgba(255, 87, 87, 0.8)'
                                : 'rgba(255,255,255,0.7)',
                              fontWeight: 500,
                            }}
                          >
                            {languageData === 'EN'
                              ? 'Name on Card'
                              : 'Nombre en la Tarjeta'}
                          </label>
                          <span
                            className="pos-abs top10 right24 text-10 pointerEventsNone"
                            style={{
                              color: hasError
                                ? 'rgba(255, 87, 87, 0.8)'
                                : 'rgba(255,255,255,0.7)',
                              fontWeight: 500,
                            }}
                          >
                            {languageData === 'EN'
                              ? '(Obligatory)'
                              : '(Obligatorio)'}
                          </span>
                        </Box>
                      );
                    }}
                  </Field>
                </Box>

                <Box mb={2} position="relative">
                  <Box className="pos-rel width100">
                    <label
                      htmlFor="card-element"
                      className="pos-abs top8 left16 text-14 pointerEventsNone"
                      style={{
                        color: 'rgba(255,255,255,0.7)',
                        fontWeight: 500,
                      }}
                    >
                      {languageData === 'EN'
                        ? 'Card Details'
                        : 'Datos de la Tarjeta'}
                    </label>
                    <span
                      className="pos-abs top10 right24 text-10 pointerEventsNone"
                      style={{
                        color: 'rgba(255,255,255,0.7)',
                        fontWeight: 500,
                      }}
                    >
                      {languageData === 'EN' ? '(Obligatory)' : '(Obligatorio)'}
                    </span>
                    <div
                      className="grayShadowBottom width100 padt30 padr14 padb10 padl12 boxSizing_borderBox outlineNone borderrad18"
                      style={{
                        border: '2px solid rgba(255,255,255,0.4)',
                        transition: 'all 0.2s ease',
                      }}
                    >
                      <CardElement
                        id="card-element"
                        options={cardElementOptions}
                      />
                    </div>
                  </Box>
                </Box>

                <Box mb={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={values.isDefault}
                        onChange={e =>
                          setFieldValue('isDefault', e.target.checked)
                        }
                        sx={{
                          color: 'rgba(255,255,255,0.4)',
                          '&.Mui-checked': {
                            color: 'white',
                          },
                        }}
                      />
                    }
                    label={
                      <Label className="text-12 fontManrope">
                        {languageData === 'EN'
                          ? 'Set as default payment method'
                          : 'Establecer como método de pago predeterminado'}
                      </Label>
                    }
                  />
                </Box>

                <FlexContainer className="width100 margb20">
                  <Label
                    className="width100 height-1px"
                    style={{ backgroundColor: 'rgba(255,255,255)' }}
                  />
                </FlexContainer>

                <Box mb={3} position="relative">
                  <Field name="email">
                    {({ field, form }) => {
                      const hasError = form.errors.email && form.touched.email;

                      return (
                        <Box className="pos-rel width100">
                          <input
                            {...field}
                            type="email"
                            maxLength={100}
                            placeholder="email@email.com"
                            onInput={e => {
                              field.onChange(e);
                              // Convertir a minúsculas
                              e.target.value = e.target.value.toLowerCase();
                            }}
                            onKeyPress={e => {
                              if (e.key === ' ') {
                                e.preventDefault();
                              }
                            }}
                            onBlur={e => {
                              field.onBlur(e);
                              form.setFieldTouched('email', true);
                            }}
                            className="grayShadowBottom placeholder-custom width100 padt30 padr14 padb10 padl12 fontWhite text-16 boxSizing_borderBox outlineNone borderrad18"
                            style={{
                              backgroundColor: hasError
                                ? 'rgba(255, 87, 87, 0.1)'
                                : 'rgba(255,255,255,0)',
                              border: hasError
                                ? '2px solid rgba(255, 87, 87, 0.8)'
                                : '2px solid rgba(255,255,255,0.4)',
                              transition: 'all 0.2s ease',
                              paddingRight: hasError ? '40px' : '14px',
                            }}
                            onFocus={e => {
                              e.target.style.backgroundColor =
                                'rgba(255,255,255,0.12)';
                              e.target.style.borderColor =
                                'rgba(255,255,255,0.6)';
                            }}
                          />
                          <label
                            htmlFor="email"
                            className="pos-abs top8 left16 text-14 pointerEventsNone"
                            style={{
                              color: hasError
                                ? 'rgba(255, 87, 87, 0.8)'
                                : 'rgba(255,255,255,0.7)',
                              fontWeight: 500,
                            }}
                          >
                            {languageData === 'EN'
                              ? 'Billing Contact'
                              : 'Contacto de Facturación'}
                          </label>
                          <span
                            className="pos-abs top10 right24 text-10 pointerEventsNone"
                            style={{
                              color: hasError
                                ? 'rgba(255, 87, 87, 0.8)'
                                : 'rgba(255,255,255,0.7)',
                              fontWeight: 500,
                            }}
                          >
                            {languageData === 'EN'
                              ? '(Obligatory)'
                              : '(Obligatorio)'}
                          </span>
                        </Box>
                      );
                    }}
                  </Field>
                </Box>

                <Button
                  className={'bgGradientSignUpPurple grayShadowBottom'}
                  type="submit"
                  fullWidth
                  sx={{
                    mt: '5px',
                    py: 0.8,
                    color: 'white',
                    borderRadius: '10px',
                    textTransform: 'none',
                    transition: 'all 0.2s ease',
                    fontSize: '16px',
                    '&:hover': {
                      boxShadow: '0 6px 16px rgba(248, 87, 166, 0.5)',
                      transform: 'translateY(-1px)',
                    },
                    '&:disabled': {
                      opacity: 0.7,
                    },
                  }}
                  disabled={loading || isSubmitting || !stripe}
                >
                  {loading
                    ? languageData === 'EN'
                      ? 'Loading...'
                      : 'Cargando...'
                    : languageData === 'EN'
                      ? 'Save Card'
                      : 'Guardar Tarjeta'}
                </Button>
              </Form>
            )}
          </Formik>
        </FlexContainer>
      </FlexContainer>
    </FlexContainer>
  );
};

export default PaymentDataView;
